import { useEffect, useMemo, useRef, useState } from "react";
import FadeIn from "react-fade-in";
import {
  get_acd_applications,
  get_call_groups,
  get_company_calls,
  get_dynamic_site,
  get_external_contacts,
  get_incoming_call_routings,
  get_internal_contacts,
  get_key_profiles,
  get_monitor_settings,
  get_my_call_groups,
  get_my_call_handling,
  get_my_calls,
  get_my_phone_XTone,
  get_my_voicemail,
  get_permission_profiles,
  get_phone_inventory,
  get_selective_call_routing,
  get_speed_dials,
  getBusinessDetails_Xtone,
  getBusinessHours_XTone,
  getPersonalDetails_XTone,
  getToken,
  myXToneLogout,
} from "../../services/api";
import Notification from "../../atom/Notification";
import { Backdrop } from "@mui/material";
import Lottiefy from "../../atom/lottie/lottie";
import * as loaderLottie from "../../utils/lottie/loaderLottie.json";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getENVData } from "../../config/environment";
import { LogoutIcon } from "../../utils/icons/defaultIcons";
import Loader from "../loader";

function MyXtone() {
  const [loader, setLoader] = useState<boolean>(true);
  const [logoutLoader, setLogoutLoader] = useState<boolean>(false);
  const [errorPage, setErrorPage] = useState<boolean>(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedMenu, setSelectedMenu] = useState<string>("");
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const rawMenu = useSelector((state: any) => state?.myXToneMenu?.menuList);
  console.log("myxtonee");
  const silMenu: any = useMemo(() => {
    const menu = [];
    if (rawMenu?.user?.length) {
      menu.push({ label: "User", items: rawMenu.user });
    }
    if (rawMenu?.admin?.length) {
      menu.push({ label: "Admin", items: rawMenu.admin });
    }
    return menu;
  }, [rawMenu]);

  const navigate = useNavigate();
  const path = useLocation();

  const menuConfig: any = {
    my_personal_details: {
      redirectUrl: getPersonalDetails_XTone,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/usr_personal?MessageID=-1`,
    },
    my_phone: {
      redirectUrl: get_my_phone_XTone,
      apiUrl: `${getENVData().xToneBaseURL}webadmin/basic/MyPhone.do`,
    },
    my_voicemail: {
      redirectUrl: get_my_voicemail,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/MyVoiceMail.do?MessageID=-1`,
    },
    my_call_handling: {
      redirectUrl: get_my_call_handling,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/MyCallHandling.do?MessageID=-1`,
    },
    selective_call_routing: {
      redirectUrl: get_selective_call_routing,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/MySCR.do?MessageID=-1`,
    },
    my_call_groups: {
      redirectUrl: get_my_call_groups,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/usr_call_groups?MessageID=-1`,
    },
    dynamic_site: {
      redirectUrl: get_dynamic_site,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/DynamicSite.do?MessageID=-1`,
    },
    my_calls: {
      redirectUrl: get_my_calls,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/MyCallList.do?MessageID=-1`,
    },
    internal_contacts: {
      redirectUrl: get_internal_contacts,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/Search.do?area=searchitem.internaldirectory.lastName&MessageID=-1`,
    },
    external_contacts: {
      redirectUrl: get_external_contacts,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/Search.do?area=searchitem.externaldirectory.name&MessageID=-1`,
    },
    business_details: {
      redirectUrl: getBusinessDetails_Xtone,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/admin/BusinessDetails.do?MessageID=-1`,
    },
    business_hours: {
      redirectUrl: getBusinessHours_XTone,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/admin/Search.do?area=searchitem.businesshour.name&MessageID=-1`,
    },
    call_groups: {
      redirectUrl: get_call_groups,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/admin/Search.do?area=searchitem.callgroup.description&MessageID=-1`,
    },
    incoming_call_routings: {
      redirectUrl: get_incoming_call_routings,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/admin/Search.do?area=searchitem.callrouting.incomingNumber&MessageID=-1`,
    },
    company_calls: {
      redirectUrl: get_company_calls,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/admin/CompanyCallList.do?MessageID=-1`,
    },
    acd_applications: {
      redirectUrl: get_acd_applications,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/admin/Search.do?area=searchitem.acdapplication.name&MessageID=-1`,
    },
    speed_dials: {
      redirectUrl: get_speed_dials,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/admin/Search.do?area=searchitem.speeddial.name&MessageID=-1`,
    },
    key_profiles: {
      redirectUrl: get_key_profiles,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/admin/Search.do?area=searchitem.keyprofile.description&MessageID=-1`,
    },
    permission_profiles: {
      redirectUrl: get_permission_profiles,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/admin/Search.do?area=searchitem.permissionprofile.description&MessageID=-1`,
    },
    phone_inventory: {
      redirectUrl: get_phone_inventory,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/admin/Search.do?area=searchitem.phoneinventory.description&MessageID=-1`,
    },
    monitor_settings: {
      redirectUrl: get_monitor_settings,
      apiUrl: `${
        getENVData().xToneBaseURL
      }webadmin/basic/admin/Search.do?area=searchitem.monitorgroup.extension&MessageID=-1`,
    },
  };

  const fetchPersonalDetails = async () => {
    const apiConfig = menuConfig[selectedMenu];
    if (!apiConfig) return;

    setLoader(true);
    apiConfig.redirectUrl(getToken()).then((result: any) => {
      if (!result.success) {
        let msg = result?.message;

        setLoader(false);
        if (result?.parameter === "pin") {
          Notification(
            "Failed",
            msg?.charAt(0).toUpperCase() + msg.slice(1),
            "danger"
          );
          setErrorPage(false);
          navigate(`/app/myxtone/login`, { replace: true });
        } else {
          setErrorPage(true);
        }
      } else {
        setErrorPage(false);
        setLoader(false);
        setTimeout(() => {
          if (iframeRef.current) {
            setLoader(false);
            iframeRef.current.src = apiConfig.apiUrl;
          }
        }, 500);
      }
    });
  };

  const labelMap: Record<string, string> = {
    my_phone: "My Phones",
    my_voicemail: "My Voice Mail",
    incoming_call_routings: "Incoming Call Routing",
    acd_applications: "ACD Applications",
    speed_dials: "External Contacts / Speed Dials",
    key_profiles: "Phone Key Profiles",
    permission_profiles: "Call Permission Profiles",
    monitor_settings: "Monitor Groups",
    dynamic_site: "My Dynamic Site",
  };

  const upperCase = (str: string) => {
    if (labelMap[str]) return labelMap[str];
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const addStyle = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const iframeDoc: any =
      iframe.contentDocument || iframe.contentWindow?.document;
    if (!iframeDoc) return;
    const style = iframeDoc.createElement("style");
    style.textContent = `
      table, th, td {
        border: none !important;
        border-collapse: collapse !important;
      }
      table {
        border: 0 !important;
        border-style: none !important;
        border-width: 0px !important;
      }
    `;
    iframeDoc.head.appendChild(style);
  };

  const handleLogout = () => {
    setLogoutLoader(true);
    myXToneLogout(getToken()).then((result: any) => {
      if (!result.success) {
        let msg = result?.message;
        Notification(
          "Failed",
          msg?.charAt(0).toUpperCase() + msg.slice(1),
          "danger"
        );
        setLogoutLoader(false);
      } else {
        navigate(`/app/myxtone/login`, { replace: true });
        Notification("Success", "Logged out successfully", "success");
        setLogoutLoader(false);
      }
    });
  };

  useEffect(() => {
    if (selectedMenu) {
      fetchPersonalDetails();
    }
    if (!rawMenu || Object.keys(rawMenu).length === 0) {
      navigate(`/app/myxtone/login`, { replace: true });
    }
  }, [selectedMenu]);

  useEffect(() => {
    if (silMenu.length > 0 && !selectedMenu) {
      setSelectedMenu(silMenu[0].items[0]); // Default to first item
      setSelectedIndex(0);
    }
  }, [silMenu, selectedMenu]);

  return (
    <div className="h-full py-0 relative rounded-md">
      <div className="flex h-[calc(100vh-125px)] w-full overflow-hidden rounded-md">
        {/* Sidebar */}
        <div
          className={`w-64 p-4 mt-[18px] space-y-4 scrollbar-hide  ${
            silMenu.admin ? "" : "border-r-2 border-primary"
          }  overflow-y-auto`}
        >
          <div className="flex items-center space-x-3">
            <div
              className="text-[14px] space-x-1 flex justify-center items-center bg-[#d94856] w-fit rounded-md px-2 p-1  hover:cursor-pointer"
              onClick={handleLogout}
            >
              {logoutLoader ? (
                <p> Logging out...</p>
              ) : (
                <>
                  <p> Logout XTone</p>
                  <LogoutIcon />
                </>
              )}
            </div>
            <div className="font-semibold">Ext: {rawMenu?.extension} </div>
          </div>
          {silMenu.map((section: any, sectionIdx: number) => (
            <div key={sectionIdx}>
              <div className="text-[15px] border-b border-primary flex justify-center items-center font-bold uppercase mb-2 px-2">
                {section.label}
              </div>
              {section.items.map((node: any, index: number) => {
                const globalIndex =
                  silMenu
                    .slice(0, sectionIdx)
                    .reduce((sum: any, s: any) => sum + s.items.length, 0) +
                  index;

                return (
                  <FadeIn>
                    <div
                      key={globalIndex}
                      onClick={() => {
                        setSelectedIndex(globalIndex);
                        setSelectedMenu(node);
                      }}
                      className={`w-full flex justify-center items-center text-[14px] px-2 py-1 mt-2 rounded-md hover:bg-[#FFEBD5] hover:cursor-pointer hover:scale-105 transition duration-300
            ${
              selectedIndex === globalIndex
                ? "bg-[#FFEBD5] scale-105"
                : "bg-secondary"
            }
          `}
                    >
                      {upperCase(node)}
                    </div>
                  </FadeIn>
                );
              })}
            </div>
          ))}
        </div>

        {/* Iframe */}
        <div className="flex-1 flex justify-center items-start p-4 overflow-auto">
          {errorPage ? (
            <div
              className="bg-[#fff] text-[20px]
             rounded-md text-white  font-bold w-full h-full flex justify-center items-center"
            >
              Service not available!
            </div>
          ) : loader ? (
            <div className=" w-full h-full flex justify-center items-center">
              <Lottiefy
                loop={true}
                json={loaderLottie}
                height={90}
                width={90}
              />
            </div>
          ) : (
            <FadeIn className="h-full">
              <iframe
                ref={iframeRef}
                onLoad={addStyle}
                title="Portal pages"
                style={{
                  width: "800px",
                  height: "86vh",
                  border: "none",
                }}
                allow="fullscreen"
                onError={() => console.error("iframe error")}
              />
            </FadeIn>
          )}
        </div>
      </div>
    </div>
  );
}

export default MyXtone;
